import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home.vue'
import Survey from '../views/Survey.vue'
import Segnalazione from '../views/Segnalazione.vue'
import ThankYouPage from '../views/ThankYouPage.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'home', component: Home, props: true },
  { path: '/survey', name: 'survey', component: Survey, props: true },
  { path: '/segnalation', name: 'segnalation', component: Segnalazione, props: true },
  { path: '/typage', name: 'typage', component: ThankYouPage, props: true }
]

const router = new VueRouter({
  routes
})

export default router
